import React from 'react'
import NavbarAuth from '../../components/NavBar/NavbarAuth'
import FormLogin from './FormLogin'

function Login() {
  return (
    <div className="grid grid-cols-5 bg-gray-100 dark:bg-dark-2">
      <NavbarAuth textButton={"S'inscrire"} link={"https://app.gonextmaker.com/auth/signup"} />

      {/* Partie image */}
      <div
        className="group col-span-2 w-full bg-cover bg-center bg-no-repeat relative overflow-hidden min-h-screen"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1600&q=80')"
        }}
      />

      {/* Formulaire */}
      <div className="col-span-3 bg-bg-beige-100 flex items-center justify-center overflow-y-auto min-h-screen">
        <div className="max-w-[535px] px-4">
          <div className="bg-white rounded-lg px-6 py-8 dark:bg-dark-1">
            <FormLogin />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login